// extracted by mini-css-extract-plugin
module.exports = {"root":"hero-module--root--3EOE0","headlines":"hero-module--headlines--2G023","buttons":"hero-module--buttons--3b33T","wrapper":"hero-module--wrapper--2w69f"};